import service from "@irati/utils/tracking/index";
var tracking = {
    view: function (page, data) {
        service.trackPlatformEvent("platform_view_" + page, data);
    },
    click: function (item, data) {
        service.trackPlatformEvent("platform_click_" + item, data);
    },
    openLiveChat: function () {
        service.trackPlatformEvent("platform_opened_live_chat", {});
    },
    clickHeaderHomeButton: function (data) {
        service.trackPlatformEvent("platform_click_header_home", data);
    },
    clickHeaderMyAccount: function (data) {
        service.trackPlatformEvent("platform_click_header_myaccount", data);
    },
    notificationOptInSkipped: function () {
        service.trackPlatformEvent("platform_notifications_optin_skipped", {});
    },
    notificationOptInStarted: function () {
        service.trackPlatformEvent("platform_notifications_optin_started", {});
    },
    notificationOptInCompleted: function () {
        service.trackPlatformEvent("platform_notifications_optin_completed", {});
    },
    notificationOptInSeen: function () {
        service.trackPlatformEvent("platform_notifications_optin_seen", {});
    },
    loadingSeen: function () {
        service.trackPlatformEvent("platform_loading_seen", {});
    },
    loadingCompleted: function () {
        service.trackPlatformEvent("platform_loading_completed", {});
    },
    onBoarding: function (step) {
        service.trackPlatformEvent("onboarding_view_step", { step: step });
    },
    onBoardingComplete: function () {
        service.trackPlatformEvent("onboarding_complete", {});
    }
};
export default tracking;
